(() => {
  const selector = '[data-novarlo-parts-accessories]';
  const setup = (rail) => {
    if (rail.dataset.novarloPartsAccessoriesReady === 'true') return;
    const viewport = rail.querySelector('[data-novarlo-parts-accessories-viewport]');
    const controls = rail.querySelector('[data-novarlo-parts-accessories-controls]');
    const prev = rail.querySelector('[data-novarlo-parts-accessories-prev]');
    const next = rail.querySelector('[data-novarlo-parts-accessories-next]');
    if (!viewport || !controls || !prev || !next) return;
    rail.dataset.novarloPartsAccessoriesReady = 'true';
    const update = () => {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const hasOverflow = maxScroll > 2;
      controls.hidden = !hasOverflow;
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= maxScroll - 2;
    };
    const scroll = (direction) => {
      const amount = Math.max(viewport.clientWidth * 0.82, 240);
      viewport.scrollBy({ left: direction * amount, behavior: 'smooth' });
    };
    prev.addEventListener('click', () => scroll(-1));
    next.addEventListener('click', () => scroll(1));
    viewport.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(viewport);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }
    update();
  };
  const init = (root = document) => {
    if (root.matches?.(selector)) setup(root);
    root.querySelectorAll?.(selector).forEach(setup);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
